import React, { useContext } from 'react';
import _merge from 'lodash/merge';
import CheckCircleIcon from '@nokia-csf-uxr/ccfk-assets/CheckCircleIcon';
import { getContext } from 'common';
import { StepContext, HorizontalStepContext } from 'components/StepForm';

import Styled, { ICON_SIZE } from './styles';

const INDICATOR_STYLE = {
  border: 'none',
};

export interface StepCompletedIndicatorProps {
  /** To override the default CheckCircleIcon.  */
  icon?: React.ReactNode;
  /** Apply properties to the default Icon. */
  iconProps?: {};
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
  /** @ignore */
  style?: React.CSSProperties
}

/** `StepCompletedIndicator`, all other props will be provided to the wrapper. */
const StepCompletedIndicator = React.forwardRef<HTMLElement, StepCompletedIndicatorProps>((props: StepCompletedIndicatorProps, ref) => getContext(({ theme }) => {
  const { icon, iconProps, theme: themeProp, ...otherProps } = props;
  const stepContext = useContext(StepContext);
  const horizontalStepContext = useContext(HorizontalStepContext);
  const resolvedTheme = _merge({}, theme.STEP_FORM, themeProp.STEP_FORM || themeProp);
  const { style: propsStyle, ...restOfOtherProps } = otherProps;
  const isDisabled = stepContext.disabled || horizontalStepContext.disabled;
  const indicatorColor = isDisabled ? resolvedTheme.BUTTON.completed.disabled : resolvedTheme.BUTTON.completed.icon;
  return (
    <Styled.StepIndicator
      ref={ref}
      $theme={resolvedTheme}
      disabled={isDisabled}
      style={_merge({}, INDICATOR_STYLE, propsStyle)}
      {...restOfOtherProps}
    >
      <Styled.StepIndicatorInside>
        {icon || <CheckCircleIcon size={ICON_SIZE} color={indicatorColor} {...iconProps} />}
      </Styled.StepIndicatorInside>
    </Styled.StepIndicator>
  );
}));

StepCompletedIndicator.defaultProps = {
  icon: undefined,
  iconProps: {},
  theme: {},
  style: {}
};

StepCompletedIndicator.displayName = 'StepCompletedIndicator';

export default StepCompletedIndicator;